import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import multiguard from 'vue-router-multiguard';

import { sessionStore } from '@/store/session';
import Home from '@/views/Home.vue';

Vue.use(VueRouter);

const isEventSelected = (to: any, from: any, next: any) => {
  if (sessionStore.session?.company.publicKey === sessionStore.session?.event?.idCompany) {
    next();
  } else {
    next('/events');
  }
};

const auth = (to: any, from: any, next: any) => {
  if (sessionStore.session?.user?.authenticated) {
    next();
  } else {
    next('/login');
  }
};

const noAuth = (to: any, from: any, next: any) => {
  if (!sessionStore.session?.user?.authenticated) {
    next();
  } else {
    next('/');
  }
};

// const showEventMenu = (instance: Vue): boolean => !!sessionStore.session.event && instance.$route.path !== '/events/';

export const routes: Array<RouteConfig & { meta: { title: string; menu?: boolean } & any }> = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: 'Login',
      menu: false,
    },
    beforeEnter: noAuth,
  },
  {
    path: '/events/',
    name: 'events',
    component: () => import('../views/Events.vue'),
    meta: {
      title: 'Gestão de Eventos',
      icon: 'fa-chart-bar',
      menu: true,
    },
    beforeEnter: auth,
  },
  {
    path: '/people/',
    name: 'people',
    component: () => import('../views/People.vue'),
    meta: {
      title: 'Inscritos',
      icon: 'fa-users',
      menu: true,
    },
    beforeEnter: auth,
  },
  {
    path: '/event/:id?',
    name: 'event',
    component: () => import('../views/Event.vue'),
    meta: {
      title: 'Evento',
      menu: false,
    },
    beforeEnter: auth,
  },
  {
    path: '/activate',
    name: 'activate',
    component: () => import('../views/Activate.vue'),
    meta: {
      title: 'Ativação',
      icon: 'fa-qrcode',
      menu: false,
    },
    beforeEnter: multiguard([auth, isEventSelected]),
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: 'Página Principal',
      menu: false,
    },
    redirect: '/subscriptions',
    beforeEnter: multiguard([auth, isEventSelected]),
  },
  {
    path: '/subscription/:id?',
    name: 'subscription',
    component: () => import('../views/Subscription.vue'),
    meta: {
      title: 'Subscription',
      menu: false,
    },
    beforeEnter: multiguard([auth, isEventSelected]),
  },
  {
    path: '/subscriptions',
    name: 'subscriptions',
    component: () => import('../views/Subscriptions.vue'),
    meta: {
      title: 'Inscrições',
      icon: 'fa-address-card',
      menu: false,
    },
    beforeEnter: multiguard([auth, isEventSelected]),
  },
  {
    path: '/infos',
    name: 'infos',
    component: () => import('../views/Infos.vue'),
    meta: {
      title: 'Informações',
      icon: 'fa-info',
      menu: false,
    },
    beforeEnter: multiguard([auth, isEventSelected]),
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: () => import('../views/Statistics.vue'),
    meta: {
      title: 'Estatísticas',
      icon: 'fa-info',
      menu: false,
    },
    beforeEnter: multiguard([auth, isEventSelected]),
  },
  // Routes end
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
